import React from 'react';
import { DropDown } from './index';
import '../../styles/fields/taginput.css';

const ORDER_TYPE_OPTIONS = [
  { id: 1, label: 'Bar Pickup', title: 'Bar Pickup' },
  { id: 2, label: 'Table Service', title: 'Table Service' },
  { id: 3, label: 'Delivery', title: 'Delivery' },
  { id: 4, label: 'Collection', title: 'Collection' },
];

const OrderTypeSelector = ({ selected = [], onChange, error, errorText }) => {
  const available = ORDER_TYPE_OPTIONS.filter((o) => !selected.includes(o.id));

  const add = (data, option) => {
    onChange([...selected, option.id]);
  };

  const remove = (id) => {
    onChange(selected.filter((s) => s !== id));
  };

  return (
    <div style={{ width: '100%', position: 'relative', paddingBottom: error ? 20 : 0 }}>
      {selected.length > 0 && (
        <div
          className={`taginput-container ${error ? 'outlined-textfield-error' : ''}`}
          style={{ minHeight: 48, alignItems: 'center', marginBottom: available.length > 0 ? 10 : 0 }}
        >
          {selected.map((id) => {
            const opt = ORDER_TYPE_OPTIONS.find((o) => o.id === id);
            return opt ? (
              <div key={id} className='taginput-tag'>
                {opt.label}
                <button type='button' onClick={() => remove(id)}>x</button>
              </div>
            ) : null;
          })}
        </div>
      )}
      {available.length > 0 && (
        <DropDown
          label='Select method'
          bold={false}
          dropdownStyle='add-venue-currency-dropdown'
          buttonStyle='add-venue-currency-dropdown-btn'
          actions={available}
          onChange={add}
        />
      )}
      {selected.length === 0 && available.length === 0 && null}
      {error && <span className='outlined-textfield-error-text'>{errorText}</span>}
    </div>
  );
};

export default OrderTypeSelector;
